/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ConnectionAverageIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABcUlEQVR4nO2UPUsDQRCGVy01Ft5MAnaCYq29CCoItpp/YGuVzMRCif4E0UYL7aPZuTSChRgUtRDr2AkGCz8LtbGK7GUvLgdivholL1wzs8yz77zsKdVRR39HmuBcM3wIYUkTngjjep5gvG0AITgTxkr004w3PuNCRamuliFHqUSvT96oMM4KwaZmvKvBCC4LqcSQaqeyWdWtCZOa4NZCnvMZb0q1Wz55Mc1YqELwUxNMthSyEO746fiM2zduhHCjmgs8NbyuH0IuHhCMuJCaE4aLhoMPQs7AmCZYEYaH4LaEr0IwEVnXfQBJ47xqVsEggn3r5KWwjMOO20WbR0m1IrOCEGIeX1jPJVWPEJZN3Tiua5gwXpvwNMOeT95gWD9cGugXgsfqjePTjost62KtXsB3uIRlFyIMq7a37QDm7NnjxgHBSmA37Jk1RHduX3zwK2kKYNbiDIvZYW9hLZfFPnvuval3oBmvon3NePpb7f/pC/lGAdNslb9xAAAAAElFTkSuQmCC)
 */
export const ConnectionAverageIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.STATUS_WARNING,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 7a1 1 0 0 0 0 2 12 12 0 0 1 12 12 1 1 0 1 0 2 0A14 14 0 0 0 3 7Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 12a1 1 0 1 0 0 2 7 7 0 0 1 7 7 1 1 0 1 0 2 0 9 9 0 0 0-9-9ZM2 17.83c0-.46.37-.83.83-.83C5.13 17 7 18.87 7 21.17c0 .46-.37.83-.83.83H3a1 1 0 0 1-1-1v-3.17Z"
        className={colorClass}
      />
    </svg>
  );
};
